<script setup lang="ts">
import ChqMenuItem from '../../components/menu/ChqMenuItem.vue';
import { setupLookup, systemUser } from "../../main-store";
</script>
<template>
    <h5 style="margin-top:0">
        Settings
    </h5>
    <ul class="sidebar-sub-menu">
        <ChqMenuItem menu-item="/settings/clinic-profile" disable-pin="true">Clinic Profile</ChqMenuItem>
        <ChqMenuItem menu-item="/settings/user-management/users" disable-pin="true">Users</ChqMenuItem>
        <ChqMenuItem menu-item="/settings/vets" disable-pin="true">Vets</ChqMenuItem>
        <ChqMenuItem menu-item="/settings/services" disable-pin="true">Services and Products</ChqMenuItem>
        <ChqMenuItem menu-item="/settings/packages" disable-pin="true">Packages</ChqMenuItem>
        <ChqMenuItem menu-item="/settings/custom-fields" disable-pin="true">Custom Fields</ChqMenuItem>
        <ChqMenuItem menu-item="/settings/tags" disable-pin="true">Tags</ChqMenuItem>
    </ul>
    <h5>
        Medical
    </h5>
    <ul class="sidebar-sub-menu">
        <ChqMenuItem menu-item="/settings/vaccine-setup" disable-pin="true">Vaccine Setup</ChqMenuItem>
        <ChqMenuItem menu-item="/settings/divvy-setup" disable-pin="true">Divvy Setup</ChqMenuItem>
        <ChqMenuItem menu-item="/settings/drug-log" disable-pin="true">Patient Flow Setup</ChqMenuItem>
        <ChqMenuItem menu-item="/settings/medical-notes" disable-pin="true">Medical Notes</ChqMenuItem>
        <ChqMenuItem menu-item="/settings/high-risk-waiver" disable-pin="true">High Risk Waiver Setup</ChqMenuItem>
        <ChqMenuItem menu-item="/settings/prescription-labels" disable-pin="true">Prescription Labels</ChqMenuItem>
        <ChqMenuItem menu-item="/settings/microchips" disable-pin="true">Microchips</ChqMenuItem>
    </ul>
    <h5>
        Scheduling
    </h5>
    <ul class="sidebar-sub-menu">
        <ChqMenuItem menu-item="/settings/capacity-management" disable-pin="true">Capacity Management</ChqMenuItem>
        <ChqMenuItem menu-item="/settings/wellness" v-if="systemUser.clinic.enableWellnessScheduling"
            disable-pin="true">
            Wellness Settings</ChqMenuItem>
        <ChqMenuItem menu-item="/settings/report-templates" disable-pin="true">Templates</ChqMenuItem>
        <ChqMenuItem menu-item="/settings/online-preferences" disable-pin="true">E-Appointments</ChqMenuItem>
        <ChqMenuItem menu-item="/settings/e-payments" v-if="!setupLookup.isTrainingClinic" disable-pin="true">
            E-Payments
        </ChqMenuItem>
        <ChqMenuItem menu-item="/settings/mobile-locations" v-if="systemUser.clinic.enableMobileLocations"
            disable-pin="true">
            Mobile Locations</ChqMenuItem>
    </ul>
    <h5>
        Communications
    </h5>
    <ul class="sidebar-sub-menu">
        <ChqMenuItem menu-item="/settings/reminders/1" disable-pin="true">Confirmations & Reminders</ChqMenuItem>
        <ChqMenuItem menu-item="/settings/reminders/attachments" disable-pin="true">Email Attachments</ChqMenuItem>
        <ChqMenuItem menu-item="/settings/medical-record" disable-pin="true">Medical Record Requests</ChqMenuItem>
        <ChqMenuItem menu-item="/settings/addons/twilio" v-if="!setupLookup.isTrainingClinic" disable-pin="true">
            Call & Text Add-on
        </ChqMenuItem>
        <ChqMenuItem menu-item="/settings/e-lobby" disable-pin="true">e-Lobby</ChqMenuItem>
        <ChqMenuItem menu-item="/settings/invoices" disable-pin="true">Invoices</ChqMenuItem>
    </ul>
    <h5>
        Accounting
    </h5>
    <ul class="sidebar-sub-menu">
        <ChqMenuItem menu-item="/settings/donations" disable-pin="true">Donations</ChqMenuItem>
        <ChqMenuItem menu-item="/settings/partnerships" disable-pin="true">Funding Partnerships</ChqMenuItem>
        <ChqMenuItem menu-item="/settings/subsidies" disable-pin="true">Subsidies</ChqMenuItem>
        <ChqMenuItem menu-item="/settings/grantors" disable-pin="true">Grantors</ChqMenuItem>
        <ChqMenuItem menu-item="/settings/vc-custom-pricing" disable-pin="true">VC Custom Pricing</ChqMenuItem>
        <ChqMenuItem menu-item="/settings/taxes" disable-pin="true">Tax Info</ChqMenuItem>
        <ChqMenuItem menu-item="/settings/quick-books" disable-pin="true">QuickBooks</ChqMenuItem>
    </ul>
    <h5>Integrations</h5>
    <ul class="sidebar-sub-menu">
        <ChqMenuItem menu-item="/settings/idexx-setup" disable-pin="true">Idexx Setup</ChqMenuItem>
        <ChqMenuItem menu-item="/settings/shelters-addon" disable-pin="true">Shelter Addon</ChqMenuItem>
    </ul>
    <h5>
        All Clinics
    </h5>
    <ul class="sidebar-sub-menu">
        <ChqMenuItem menu-item="/settings/chat" v-if="!setupLookup.isTrainingClinic" disable-pin="true">Chat
        </ChqMenuItem>
        <ChqMenuItem menu-item="/settings/one-link" disable-pin="true">OneLink E-Appointments</ChqMenuItem>
        <ChqMenuItem menu-item="/settings/vcp-settings" disable-pin="true">VCP Settings</ChqMenuItem>
        <ChqMenuItem menu-item="/settings/vault" disable-pin="true">The Vault</ChqMenuItem>
    </ul>
</template>